const parsePercentageGrade = (value) => {
  const parsedGrade = parseInt(value, 10);
  return parsedGrade >= 0 && parsedGrade <= 100 ? parsedGrade : undefined;
};

export default parsePercentageGrade;
